// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IIdNameDto } from './IIdNameDto';
import {
    IIdNameDtoFromJSON,
    IIdNameDtoFromJSONTyped,
    IIdNameDtoToJSON,
    IIdNameDtoToJSONTyped,
} from './IIdNameDto';

/**
 * 
 * @export
 * @interface IPaymentRuleDto
 */
export interface IPaymentRuleDto {
    /**
     * 
     * @type {number}
     * @memberof IPaymentRuleDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPaymentRuleDto
     */
    plan_id?: number;
    /**
     * 
     * @type {IIdNameDto}
     * @memberof IPaymentRuleDto
     */
    plan?: IIdNameDto;
    /**
     * 
     * @type {number}
     * @memberof IPaymentRuleDto
     */
    max_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IPaymentRuleDto
     */
    percentage?: number;
}

/**
 * Check if a given object implements the IPaymentRuleDto interface.
 */
export function instanceOfIPaymentRuleDto(value: object): value is IPaymentRuleDto {
    return true;
}

export function IPaymentRuleDtoFromJSON(json: any): IPaymentRuleDto {
    return IPaymentRuleDtoFromJSONTyped(json, false);
}

export function IPaymentRuleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPaymentRuleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'plan_id': json['plan_id'] == null ? undefined : json['plan_id'],
        'plan': json['plan'] == null ? undefined : IIdNameDtoFromJSON(json['plan']),
        'max_amount': json['max_amount'] == null ? undefined : json['max_amount'],
        'percentage': json['percentage'] == null ? undefined : json['percentage'],
    };
}

export function IPaymentRuleDtoToJSON(json: any): IPaymentRuleDto {
    return IPaymentRuleDtoToJSONTyped(json, false);
}

export function IPaymentRuleDtoToJSONTyped(value?: IPaymentRuleDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'plan_id': value['plan_id'],
        'plan': IIdNameDtoToJSON(value['plan']),
        'max_amount': value['max_amount'],
        'percentage': value['percentage'],
    };
}

